import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { BaseDialog } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import theme from 'theme'
import * as service from 'service'
import helpers from 'helpers'

const DeleteInventoryModal = ({
  open,
  setOpen,
  setLoading,
  refresh,
  assetInventoryId,
}) => {
  const snackbar = useSnackbar()

  const onSubmit = async (event) => {
    event.preventDefault()

    try {
      setLoading(true)

      await service.dponet.assetInventory.destroy({ assetInventoryId })

      snackbar.open({
        message: 'Inventário de ativos excluído com sucesso!',
        variant: 'success',
      })
      refresh()
      setOpen(false)
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error) ||
          'Ocorreu um erro ao excluir o inventário de ativos.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Excluir Inventário de Ativos"
      actionButtonText="Excluir"
      closeButtonText="Cancelar"
      formRef="asset-inventory-destroy-form"
    >
      <Box
        component="form"
        id="asset-inventory-destroy-form"
        onSubmit={onSubmit}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
      >
        <Box>
          <Typography variant="h6">
            Tem certeza que deseja excluir o ativo?
          </Typography>
          <Typography gutterBottom>
            Não será possível desfazer essa ação!
          </Typography>
        </Box>
        <Alert severity="warning" variant="standard">
          <AlertTitle>Ciclos de vida vinculados</AlertTitle>
          Todos os ciclos de vida vinculados a este inventário de ativos serão
          automaticamente transferidos para a categoria deste inventário.
        </Alert>
      </Box>
    </BaseDialog>
  )
}

DeleteInventoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  assetInventoryId: PropTypes.number.isRequired,
}

export default DeleteInventoryModal
